import React, {useEffect, useState} from "react";
import _ from 'lodash'
import {Accordion, AccordionTab} from "primereact/accordion";
import {Checkbox} from "primereact/checkbox";


export const Specifications = ({specList, filterType, checkedFiltersObject, setCheckedFiltersObject}) => {

    const [specListGrouped, setSpecListGrouped] = useState([])
    const [keys, setKeys] = useState([])

    const isCheck = (id) => {
        for(let i =0; i < checkedFiltersObject[filterType].length; i++){
            if(checkedFiltersObject[filterType][i].Id ===id){
                return true;
            }
        }
        return false
    }

    const handleSpecChange = (e) => {
        console.log(e.target.id)
        console.log(e.target.checked)
        debugger
        let isExist = _.find(checkedFiltersObject[filterType], ['Id', e.target.id]);
        let deepClone = _.cloneDeep(checkedFiltersObject);

        if(e.target.checked && !isExist){
            const filterModel = {Id: e.target.id, Name: e.target.value};
            deepClone[filterType].push(filterModel)
            setCheckedFiltersObject(deepClone);
        }
        else if(!e.target.checked && isExist){
            _.remove(deepClone[filterType], function(n) {
                return n.Id === e.target.id
            });
            setCheckedFiltersObject(deepClone);
        }
    }

    useEffect(() => {
        if(specList){
            try {
                const grouped = _.groupBy(specList, 'SpecificationName');
                const keys =  _.keys(grouped);
                setKeys(keys);
                console.log(keys);
                setSpecListGrouped(grouped);
            }
            catch (err){
                console.log(err)
            }
        }
    },[specList])

    if(!keys){
        return (<div>Спецификаций нет</div>)
    }

    return (
        <div>
            {keys.map((specKey, index) =>
                    <Accordion key={specKey} >
                        <AccordionTab header={
                            <div className="flex align-items-center">
                                <i className="pi pi-book mr-2"></i>
                                <span className="vertical-align-middle">{specKey.toString()}</span>
                            </div>
                        }>
                            {specListGrouped[specKey.toString()].map((spec, index) =>
                                <div  key={spec.Id.toString()}>
                                    <Checkbox onChange={handleSpecChange} type="checkbox" id={spec.Id} value={spec.SpecificationValue} label={spec.SpecificationValue}  checked={isCheck(spec.Id)}/*checked={filter.IsChecked}*/ />
                                    <label htmlFor="ingredient1" className="ml-2">{spec.SpecificationValue}</label>
                                </div>
                            )}
                        </AccordionTab>
                    </Accordion>
            )}
        </div>
    )
}